export default "__VITE_ASSET__QzZG0G8A__"